import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import ReactTable from 'react-table';
import { Button, Grid } from 'semantic-ui-react';

import { fetchCalendars } from './state/calendarList/actions';
import {
  clearSchoolCalendarErrorSuccess,
  deleteCalendar,
} from './state/calendar/actions';

import { Filter, Main } from 'Containers';
import { GridContextMenu } from 'Components/app/contextmenu/ContextMenuManager';
import { getFiscalYear } from 'Common/GeneralHelper';
import { errorToast, createToast, toastType } from 'Common/ToastHelper';
import { DeleteDialog } from './components/DeleteDialog';
import { SchoolCalendarFieldEnum as Fields } from 'Common/FieldEnum';

import 'PageStyles/schoolcalendar/index.less';

class SchoolCalendarContainer extends Component {
  state = {
    sorted: [{ id: 'FiscalYear', desc: false }],
    filtered: [],
    deleteDialog: {
      shown: false,
      calendar: null,
    },
  };

  componentDidMount() {
    this.setState({
      filtered: [{ id: 'FiscalYear', value: getFiscalYear(new Date()) }],
    });
    this.props.fetchCalendars();
  }

  componentDidUpdate(prevProps) {
    const { clearSchoolCalendarErrorSuccess } = this.props;

    if (errorToast(this.props, prevProps, 'deleteError')) {
      clearSchoolCalendarErrorSuccess();
    } else if (this.props.deleted && !prevProps.deleted) {
      createToast(
        toastType.success,
        'Success',
        'School Calendar deleted successfully',
        true
      );

      this.props.fetchCalendars();
      clearSchoolCalendarErrorSuccess();
    }
  }

  onEditMenuClick = calendar => {
    this.props.history.push(`/schoolcalendar/${calendar.Id}`);
  };

  onDeleteMenuClick = calendar => {
    this.setState({
      deleteDialog: {
        shown: true,
        calendar,
      },
    });
  };

  onDeleteConfirm = () => {
    this.props.deleteCalendar(this.state.deleteDialog.calendar.Id);
    this.onDeleteCancel();
  };

  onDeleteCancel = () => {
    this.setState({
      deleteDialog: {
        shown: false,
        calendar: null,
      },
    });
  };

  columns = [
    {
      Header: 'Description',
      accessor: 'Description',
      filterable: true,
    },
    {
      Header: 'First Day of School',
      accessor: Fields.FirstDayDT,
    },
    {
      Header: 'Last Day of School',
      accessor: Fields.LastDayDT,
    },
    {
      Header: 'Meal Benefit Expiration',
      accessor: Fields.MealExpirationDT,
    },
    {
      Header: 'Fiscal Year',
      accessor: Fields.FiscalYear,
      filterable: true,
    },
    {
      width: 40,
      sortable: false,
      resizable: false,
      style: { textAlign: 'center' },
      Cell: gridProps => {
        return gridProps.original.Id === 0
          ? null
          : GridContextMenu({ gridProps, options: this.menuOptions });
      },
    },
  ];

  menuOptions = [
    {
      icon: 'pencil',
      text: 'Edit',
      handler: this.onEditMenuClick,
    },
    {
      icon: 'trash',
      text: 'Delete',
      className: 'danger',
      handler: this.onDeleteMenuClick,
      disabledWhen: x => this.props.isReadOnly,
    },
  ];

  onAddClick = () => {
    this.props.history.push('/schoolcalendar/0');
  };

  onSorted = sorted => this.setState({ sorted });
  onFiltered = filtered => this.setState({ filtered });

  render() {
    const { calendars, fetching, isReadOnly, deleting } = this.props;

    return (
      <Fragment>
        <Filter title={'School Calendar'}>
          <Grid>
            <Grid.Row>
              <Grid.Column floated={'right'} textAlign={'right'}>
                <Button
                  content="Add New Calendar"
                  onClick={this.onAddClick}
                  disabled={isReadOnly}
                />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Filter>
        <Main>
          <DeleteDialog
            {...this.state.deleteDialog}
            onConfirm={this.onDeleteConfirm}
            onCancel={this.onDeleteCancel}
          />
          <ReactTable
            columns={this.columns}
            data={calendars}
            filtered={this.state.filtered}
            loading={fetching || deleting}
            minRows={5}
            onSortedChange={this.onSorted}
            onFilteredChange={this.onFiltered}
            showPageSizeOptions={false}
            sorted={this.state.sorted}
          />
        </Main>
      </Fragment>
    );
  }
}
const mapStateToProps = state => {
  const { SchoolCalendarState } = state;

  return {
    calendars: SchoolCalendarState.calendarList.data,
    fetching: SchoolCalendarState.calendarList.fetching,
    deleted: SchoolCalendarState.calendar.deleted,
    deleting: SchoolCalendarState.calendar.deleting,
  };
};

export const SchoolCalendar = withRouter(
  connect(
    mapStateToProps,
    {
      fetchCalendars,
      deleteCalendar,
      clearSchoolCalendarErrorSuccess,
    }
  )(SchoolCalendarContainer)
);



// WEBPACK FOOTER //
// ./src/pages/schoolcalendar/SchoolCalendar.js